<template>
    <div v-if="isScoring">
        <div v-if="isClockDrawing">
            <ClockScoreNum 
                ref="clockScore"
                :value="clockDrawingScore" 
                @input="updateScore" 
            />
            <NotesEnabled ref="scoringNotes" :content="scoringNotes" label="Scoring Notes:" />
        </div>
        <template v-else>
            <NotesEnabled ref="scoringNotes" :content="scoringNotes" label="Scoring Notes:" />
        </template>
        <NotesDisabled ref="administeringNotes" :content="administeringNotes" />
    </div>
    <div v-else>
        <NotesEnabled ref="administeringNotes" :content="administeringNotes" label="Administering Notes:" />
    </div>
</template>
  
<script>
import NotesEnabled from './NotesEnabled.vue';
import NotesDisabled from './NotesDisabled.vue';
import ClockScoreNum from './ClockScoreNum.vue';
  
export default {
    components: {
        NotesEnabled,
        NotesDisabled,
        ClockScoreNum
    },
    props: {
        administeringNotes: {
            type: String,
            default: ''
        },
        scoringNotes: {
            type: String,
            default: ''
        },
        clockDrawingScore: {
            type: String,
            default: ''
        },
        isClockDrawing: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentScore: ''
        };
    },
    computed: {
        isScoring() {
            return this.$route.query.selection === 'score';
        },
        displayAdministering() {
            return !this.isScoring;
        },
        displayScoring() {
            return this.isScoring;
        }
    },
    methods: {
        updateScore(value) {
            this.currentScore = value;
        },
        getAdministeringNotes() {
            return this.displayAdministering && this.$refs.administeringNotes 
                ? this.$refs.administeringNotes.getNotes() 
                : this.administeringNotes;
        },
        getScoringNotes() {
            return this.displayScoring && this.$refs.scoringNotes 
                ? this.$refs.scoringNotes.getNotes() 
                : this.scoringNotes;
        },
        getClockDrawingScore() {
            if (this.isClockDrawing && this.isScoring) {
                const clockScore = this.$refs.clockScore;
                return clockScore ? clockScore.getScore() : '';
            }
            return '';
        }
    },
    mounted() {
        if (this.administeringNotes) {
            this.$refs.administeringNotes.content = this.administeringNotes;
        }
        
        if (this.isScoring && !this.isClockDrawing && this.scoringNotes) {
            this.$refs.scoringNotes.content = this.scoringNotes;
        }
        
        // Set initial clock drawing score if available
        if (this.isClockDrawing && this.isScoring && this.$refs.clockScore) {
            this.$refs.clockScore.content = this.clockDrawingScore;
        }
    }
};
</script>

<style scoped>
.score-input-container {
    margin-bottom: 20px;
}

.score-input-container label {
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
}

.score-input {
    padding: 8px;
    width: 80px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.score-error {
    color: red;
    margin-top: 4px;
    font-size: 14px;
}
</style>